import { useWishlist } from '../hooks/useWishlist';

type WishlistIconProps = {
	fill: boolean;
};

const WishlistIcon = ({ fill }: WishlistIconProps) => {
	const { blockClass } = useWishlist();

	return (
		<span
			className={`wishlistIcon wishlistIcon--${blockClass} vtex-wish-list-1-x-wishlistIcon ${blockClass && `vtex-wish-list-1-x-wishlistIcon--${blockClass}`} ${fill ? 'vtex-wish-list-1-x-fill fill' : 'vtex-wish-list-1-x-outline outline'} vtex-wish-list-1-x-iconSize`}
		></span>
	);
};

export default WishlistIcon;
